import { render, staticRenderFns } from "./RecruiterAssessmentIndex.vue?vue&type=template&id=3c92d007&scoped=true"
import script from "./RecruiterAssessmentIndex.vue?vue&type=script&lang=ts"
export * from "./RecruiterAssessmentIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92d007",
  null
  
)

export default component.exports